import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { Subscription as RxSubscription } from 'rxjs';

import { OrganisationDataSource } from '../../services/organisation-data-source';

@Component({
    selector: 'organisation-picker-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class OrganisationPicker implements OnInit, OnDestroy {
  public selectedOrganisation: { id: number; hasBranches: boolean };

  public displayedColumns = ['title', 'actions'];

  public loading: boolean;

  public PageEvent: NgPageEvent;
  public filter: {};

  private Subscriptions: RxSubscription[] = [];

  constructor(
    private DialogRef: MatDialogRef<OrganisationPicker>,
    @Inject(MAT_DIALOG_DATA) public DataSource: OrganisationDataSource
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (PageEvent) => (this.PageEvent = PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe((filter) => {
        this.filter = filter;
        this.DataSource.loadWithPageEvent(this.PageEvent);
      })
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public load(PageEvent: NgPageEvent) {
    this.DataSource.loadWithPageEvent(PageEvent);
  }

  public setSelectedOrganisation(id: number, hasBranches: boolean) {
    this.selectedOrganisation =
      this.selectedOrganisation?.id !== id
        ? { id: id, hasBranches: hasBranches }
        : null;
  }

  public selectOrganisation() {
    this.DialogRef.close(this.selectedOrganisation);
  }
}
